<template>
    <div>
        <!-- Alterar Extra -->
        <div class="modal fade" id="alterarExtra" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="marcacao">
                    <div class="modal-header">
                        <h5 class="modal-title">Alterar Extra</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">
                            <div class="lead">{{ marcacao.nome_paciente }}</div>
                            <div class="small" v-if="marcacao.procedimento">{{ marcacao.procedimento.search }}</div>
                            <div class="small" v-if="marcacao.medico">{{ marcacao.medico.search }}</div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    label="Data" 
                                    type="date"
                                    required
                                    :validate="validate"
                                    v-model="nova_data" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    label="Horário" 
                                    type="time"
                                    required
                                    :validate="validate"
                                    v-model="nova_hora" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            marcacao: null, 
            nova_data: "",
            nova_hora: "", 
            validate: false, 
        }
    },

    components: { 
        AzSubmit, 
        AzInput, 
    }, 

    methods: { 
        abrir(marcacao) { 
            this.marcacao = _.cloneDeep(marcacao);

            this.nova_data = this.marcacao.dt_inicio.slice(0, 10);
            this.nova_hora = this.marcacao.dt_inicio.slice(11, 16);

            this.validate = false; 

            $('#alterarExtra').modal('show');
        },

        atualizar() { 

            this.$util.atualizar(this, { 
                service: 'agendas',
                func: 'atualizar_extra',
                dados: { 
                    id_marcacao: this.marcacao.id_marcacao,
                    data: this.nova_data,
                    hora: this.nova_hora,
                },
                modal: 'alterarExtra',
                callback: () => { 
                    this.$emit('refresh');
                }
            });

        }
    }
}
</script>
